import { useState } from "react";
import axios from "axios";

export default function FindPw1({ onNext }) {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [id, setId] = useState("");
    const [checking, setChecking] = useState(false);

    // 숫자만 추출
    const digits = (phoneNumber || "").replace(/\D/g, "");
    const isValidPhone = /^\d{10,11}$/.test(digits);

    const handlerInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phoneNumber") {
            // ✅ 입력부터 숫자만 유지 (하이픈/공백 방지)
            const onlyDigits = value.replace(/\D/g, "");
            setPhoneNumber(onlyDigits);
            return;
        }

        if (name === "id") setId(value);
    };

    // ✅ 010xxxx -> +8210xxxx 로 통일
    const toE164KR = (raw) => {
        const only = (raw || "").replace(/\D/g, "");
        if (!only) return "";
        if (only.startsWith("0")) return "+82" + only.substring(1);
        if (only.startsWith("82")) return "+" + only;
        return only.startsWith("+") ? only : "+" + only;
    };

    const handleNext = async () => {
        if (!id.trim()) {
            alert("아이디를 입력해주세요.");
            return;
        }
        if (!isValidPhone) {
            alert("전화번호를 숫자만 10~11자리로 입력해주세요.");
            return;
        }

        const payload = {
            id: id.trim().toLowerCase(),
            phoneNumber: toE164KR(phoneNumber),
        };

        // ✅ 여기서 콘솔 확인 (가장 중요)
        console.log("[FindPw1] raw phone:", phoneNumber);
        console.log("[FindPw1] digits:", digits);
        console.log("[FindPw1] payload:", payload);

        try {
            setChecking(true);

            const { data } = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/auth/password/verify-user`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            console.log("[FindPw1] verify-user response:", data);

            if (data?.ok === true) {
                onNext(payload);
            } else {
                alert("입력하신 아이디와 전화번호가 일치하지 않습니다.");
            }
        } catch (err) {
            console.error("[FindPw1] verify-user error:", err);
            alert("사용자 확인 중 오류가 발생했습니다.");
        } finally {
            setChecking(false);
        }
    };

    const canProceed = id.trim().length > 0 && isValidPhone && !checking;

    return (
        <>
            <div className="FindId_Header">
                <p>비밀번호 찾기</p>
            </div>

            <div className="FindId_Mid">
                <p>본인확인</p>
                <p>아이디와 등록한 전화번호를 입력해주세요</p>
            </div>

            <div className="FindId_Phone">
                <div>
                    <input
                        className="input_id"
                        type="text"
                        name="id"
                        value={id}
                        onChange={handlerInputChange}
                        placeholder="아이디를 입력해주세요"
                        autoComplete="username"
                        disabled={checking}
                    />

                    <div>
                        <input
                            type="text"
                            name="phoneNumber"
                            value={phoneNumber}
                            onChange={handlerInputChange}
                            placeholder="숫자만 입력해주세요"
                            inputMode="numeric"
                            disabled={checking}
                            maxLength={11}
                        />
                    </div>
                </div>
            </div>

            <div className="FindId_button">
                <button onClick={handleNext} disabled={!canProceed}>
                    {checking ? "확인 중..." : "비밀번호 변경"}
                </button>
            </div>
        </>
    );
}
